import { Component, OnInit } from '@angular/core';
import { CfetBaseComponent, CfetPageNamesConstant, CfetService, CFETILMEndpointsConstant } from '../../../cfet-core';
import { Router } from '@angular/router';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'app-utf-auth-single-id-homepage',
    templateUrl: './utf-auth-single-id-homepage.component.html',
    styleUrls: ['./utf-auth-single-id-homepage.component.scss'],
    standalone: false
})
export class UtfAuthSingleIdHomepageComponent extends CfetBaseComponent implements OnInit {

  openCancelModal = '';
  showCancelModal = false;
  attEmail = '';
  firstName = '';
  lastName = '';
  contactEmail = '';
  attID: any;
  emailVerified: any;
  showHomepage: boolean = true;
  showIdForm: boolean = false;
  showSingleIdPage: boolean;
  altSingleId: any;
  separateIDValues: any;
  showId: any;
  httpHeaders: any = {};
  userId: any;
  EmailFormatUser: any;
  emailAddressForm: UntypedFormGroup;
  emailAddress: UntypedFormControl;
  emailAddressError: boolean;
  showDupeErrorMsg: boolean = false;
  disabledUseOneIdButton: boolean = true;
  validEmail: boolean;
  constructor(private router: Router, private cfetService: CfetService) { super(); }

  ngOnInit () {
    this.emailAddress = new UntypedFormControl('', [Validators.required]);
    this.emailAddressForm = new UntypedFormGroup({
      emailAddress: this.emailAddress
    });
    // AM Headers
    if (sessionStorage.getItem('AMUTFHeaders') && Object.keys(sessionStorage.getItem('AMUTFHeaders')).length !== 0) {
      this.httpHeaders = JSON.parse(sessionStorage.getItem('AMUTFHeaders'));
      this.attEmail = this.httpHeaders.userid;
      this.contactEmail = this.httpHeaders.email;
      this.firstName = this.httpHeaders.firstname;
      this.lastName = this.httpHeaders.lastname;
      this.emailVerified = this.httpHeaders.isEmailVerified;
      this.attID = true;
      const emailRegex = new RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/);
      this.validEmail = emailRegex.test(this.attEmail);
      this.EmailFormatUser = this.validEmail ? true : false;
    }
    this.utfSessionStorageValidation();
  }

  utfSessionStorageValidation () {
    if (sessionStorage.getItem('separateId') && Object.keys(sessionStorage.getItem('separateId')).length !== 0) {
      this.showId = JSON.parse(sessionStorage.getItem('separateId'));
      this.attEmail = this.showId.attEmail;
      this.showIdForm = this.showId.showSeparateIdForm;
      this.showHomepage = this.showIdForm ? false : true;
    } else if (sessionStorage.getItem('showSingleIdPage') && Object.keys(sessionStorage.getItem('showSingleIdPage')).length !== 0) {
      this.showSingleIdPage = JSON.parse(sessionStorage.getItem('showSingleIdPage'));
      const emailRegex = new RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/);
      this.validEmail = emailRegex.test(this.attEmail);
      this.EmailFormatUser = this.validEmail ? true : false;
    } else if (sessionStorage.getItem('altSingleId') && Object.keys(sessionStorage.getItem('altSingleId')).length !== 0) {
      this.altSingleId = JSON.parse(sessionStorage.getItem('altSingleId'));
      this.showSingleIdPage = this.altSingleId.altEmail;
      this.userId = this.altSingleId.userID;
    } else {
      this.showSingleIdPage = false;
    }
    if (sessionStorage.getItem('separateIDValues') && Object.keys(sessionStorage.getItem('separateIDValues')).length !== 0) {
      this.separateIDValues = JSON.parse(sessionStorage.getItem('separateIDValues'));
    }
  }

  validateEmailAddress () {
    const emailRegex = new RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/);
    if (this.emailAddress.value === '' || this.emailAddress.value === undefined || this.emailAddress.value === null) {
      this.disabledUseOneIdButton = true;
    } else {
      this.emailAddressError = !emailRegex.test(this.emailAddress.value);
      if (this.emailAddressError) {
        this.disabledUseOneIdButton = true;
        this.showDupeErrorMsg = false;
      } else {
        this.disabledUseOneIdButton = false;
        this.showDupeErrorMsg = false;
      }
    }
  }

  cancelModal (event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.showCancelModal = true;
      this.openCancelModal = 'open';
    }
  }

  closeModal (event) {
    if (event === 'modalClose') {
      this.openCancelModal = 'close';
    }
  }

  hideHomePage () {
    this.showHomepage = true;
    this.showIdForm = false;
    sessionStorage.removeItem('userID');
  }

  use1Id (event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      sessionStorage.removeItem('singleIdForm');
      const singleIDInfo = {
        'fName': this.firstName ? this.firstName : this.separateIDValues.firstName,
        'lName': this.lastName ? this.lastName : this.separateIDValues.lastName,
        'attEmail': this.attEmail,
        'contactEmail': this.contactEmail,
        'emailVerified': this.emailVerified,
        'attID': this.attID
      };
      sessionStorage.removeItem('separateIDValues');
      sessionStorage.setItem('ngStorage-singleIDInfo', JSON.stringify(singleIDInfo));
      this.router.navigate([CfetPageNamesConstant.CUSTOMER_PERSONAL_INFORMATION_UTF]);
    }
  }

  useSeparateId (event) {
    if (event.type === 'click' || event.key === 'Enter' || event.KeyCode === 13) {
      const request = {
        'userid': this.emailAddress.value.trim(),
        'company_id': environment.companyId,
        'notification_value': '',
        'notification_method': 'list',
        'notification_flow': 'actv'
      };
      this.cfetService.cfetLivePost(request, CFETILMEndpointsConstant.VERIFY_IDENTITY_ACTIVATION).subscribe((data) => {
        /* do nothing on success scenario */
      }, (error) => {
        // On error scenario set the session for single id form
        if (error && error.error && error.error.errorcode && error.error.errorcode === 1033) {
          sessionStorage.removeItem('singleIDInfo');
          this.attID = false;
          const singleIdForm = {
            'fName': this.firstName,
            'lName': this.lastName,
            'attEmail': this.attEmail,
            'newEmail': this.emailAddress.value,
            'emailVerified': this.emailVerified,
            'attID': this.attID,
            'separateId': true
          };
          sessionStorage.setItem('singleIdForm', JSON.stringify(singleIdForm));
          // Redirect the user to Profile Information page
          this.router.navigate([CfetPageNamesConstant.CUSTOMER_PERSONAL_INFORMATION_UTF]);
        } else {
          this.showDupeErrorMsg = true;
          this.disabledUseOneIdButton = true;
          this.emailAddressError = false;
        }
      });
    }
  }
}
